<template>
  <KycDesktop
    :ratio="1/50"
    :title="$t('Legal information')"
    :no-buttons="true"
  >
    <BaseParagraph
      class="mb-4"
      v-html="$t('KYC introduction')"
    />
    <div class="flex justify-between">
      <BaseButton
        :title="$t('Back')"
        to="/opportunities"
        theme="secondary"
      />
      <BaseButton
        :title="$t('Accept')"
        @click.native="next()"
      />
    </div>
  </KycDesktop>
</template>

<script>
import { mapActions } from 'vuex';
import kyc from '../../../mixins/kyc';
import KycDesktop from '../Desktop.vue';
import BaseParagraph from '../../../components/BaseParagraph.vue';
import BaseButton from '../../../components/BaseButton.vue';

export default {
  name: 'Introduction',
  components: {
    KycDesktop,
    BaseParagraph,
    BaseButton,
  },
  mixins: [kyc],
  methods: {
    ...mapActions('kyc', ['validateKycIntroduction']),
    next() {
      this.validateKycIntroduction();
      this.$router.push('identity');
    },
  },
};
</script>
